export class Helper {
    static isEmptyInputValue(value: any): boolean {
        /**
         * Check if the object is a string or array before evaluating the length attribute.
         * This avoids falsely rejecting objects that contain a custom length attribute.
         * For example, the object {id: 1, length: 0, width: 0} should not be returned as empty.
         */
        return (
            value == null || ((typeof value === 'string' || Array.isArray(value)) && value.length === 0)
        );
    }

    static getNonFormattedAmount(value: string): string {
        if (value) {
            value = value.replace(/\s/g, '');
            value = value.replace(/,/g, '');
        } else {
            value = '0';
        }

        return value;
    }

    static getAmountValue(value: number | string): number {
        if (value && typeof (value) === 'string') {
            return parseFloat(Helper.getNonFormattedAmount(value));
        }

        return value as number;
    }
}
